import { SceneFade } from "../shared3d/SceneFade";
import { Stage } from "../shared3d/Stage";
import { Caption } from "../shared3d/Caption";
import { CodePanel } from "../shared3d/CodePanel";
import { Node3D } from "../shared3d/Diagram3D";
import { BRAND } from "../shared3d/theme";
import { byScene } from "./script";

// Verbatim from supabase/migrations/194_llm_call_costs_rls_policy.sql
// (ENABLE RLS is mig 193; the policy is mig 194). Inline comments are
// pedagogical annotations, not part of the source.
const POLICY_SQL = `ALTER TABLE public.llm_call_costs ENABLE ROW LEVEL SECURITY;

CREATE POLICY llm_call_costs_tenant_isolation
  ON public.llm_call_costs
  USING      (tenant_id::text = (auth.jwt() ->> 'tenant_id'))
  WITH CHECK (tenant_id::text = (auth.jwt() ->> 'tenant_id'));`;

export const Scene05Code1: React.FC = () => (
  <SceneFade>
    <Stage orbit={0.05} cameraZ={9}>
      <Node3D position={[-5, 2.4, -2]} color={BRAND.violet} size={0.2} />
      <Node3D position={[5, -2.2, -2]} color={BRAND.cyan} size={0.18} />
    </Stage>
    <CodePanel
      title="supabase/migrations/194_llm_call_costs_rls_policy.sql"
      code={POLICY_SQL}
      language="sql"
      highlightLines={[5, 6]}
      revealFrames={120}
      fontSize={28}
    />
    <Caption lines={byScene.code1} />
  </SceneFade>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
